import { configureStore } from '@reduxjs/toolkit';

import resourcesReducer from './getResourcesSlice';

export const store = configureStore({
    reducer: {
        resources: resourcesReducer,
    },
});

export default store;
